// import { Component, OnInit } from '@angular/core';
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { ApplicationsListResponseModel } from "src/app/model/ApplicationsListResponseModel";
import { WaitlistService } from "src/app/services/waitlist.service";
import { data } from "src/app/audit-trail/application/data";
import { ExcelExportService } from "src/app/services/excel-export.service";
import { forkJoin } from "rxjs";



@Component({
  selector: 'app-active-waitlist',
  templateUrl: './active-waitlist.component.html',
  styleUrls: ['./active-waitlist.component.scss'],
})
export class ActiveWaitlistComponent implements OnInit {
  
  schemeCodes : String [] = [];
  lotteryCodes : String [] = [];
  categoryCodes : String [] = [];
  
  lottery: {[key:number]:string};
  schemeList: {[key:number]:string};
  categoryList: {[key:number]:string};

  page: Page<ApplicationsListResponseModel>;
  allPageDataAllWltType: ApplicationsListResponseModel [] = [];
  allPageDataAllWltTypeClmnName: string[]= ["Application no","Applicant name","Lottery Name","Status","lottery code","Draw status","Acceptance status","Eligibility status"];
  allPageDataAllWltTypeClmnWdth: string = "20,20,20,20,20,20,20,20,20";
  // dataSource: MatTableDataSource<OrganizationResponseModel> = new MatTableDataSource();
  dataSource: MatTableDataSource<BoardResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  // dataSourceLottery: MatTableDataSource<LotteryResponseModel> = new MatTableDataSource();
  dataSourceLottery: MatTableDataSource<ApplicationsListResponseModel> = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "applicant",
    // "applicantName",
    "gender",
    // "category",
    "acceptanceEndDate",
    "scheme",
    "status",
    // "incomegroup",
    // "isActive",
    "action"
  ];
  waitListTypes: string[] = ['APPLICANT SURRENDERED TENEMENT', 'ACCEPTANCE PENDING' ,'INELIGIBLE IN POST LOTTERY'];
  // waitListTypes: string[] = ['APPLICANT SURRENDERED TENEMENT', 'ACCEPTANCE PENDING' ,'INELIGIBLE IN POST LOTTERY','PAYMENT DEFAULTER'];//for PAYMENT DEFAULTER
  selectedWaitListType : any = 'APPLICANT SURRENDERED TENEMENT';
  selectedLotteryCode : string;
  selectedSchemeCode : string;
  selectedCategoryCode : string;
  constructor(public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private waitlistService: WaitlistService,
    private _snackBar: MatSnackBar,
    private excelExportService: ExcelExportService
    ) {}

    ngOnInit(): void {
      this.filterForm = new FormGroup({
        filterText: new FormControl(null),
        wlType: new FormControl("APPLICANT SURRENDERED TENEMENT"),
        lotteryCodeFilter: new FormControl("Select Lottery Code"),
        schemeCodeFilter: new FormControl("Select Scheme Code"),
        categoryCodeFilter: new FormControl("Select Category")
      });
  
      this.loadData();
     
    }

    loadData(){
      this.waitlistService.initLotteryForActivateWaitlist().subscribe((data) => {
        console.log(data);
        this.lottery = data.lotteryList;
      },
      (error) => {
          console.log(error);
          // this.isLoading = false;
          // this.isSearchDisabled = false;
      });
    }
  
    resetFilter() {
      // this.filterForm.controls['filterText'].setValue(null);
      // this.filterForm.controls['wlType'].setValue("APPLICANT SURRENDERED TENEMENT");
      // this.filterForm.controls['selectedLotteryCode'].setValue("Select Lottery Code");
      // this.filterForm.controls['schemeCodeFilter'].setValue("Select Scheme Code");
      // this.filterForm.controls['categoryCodeFilter'].setValue("Select Category");
      // this.onLoad();
      window.location.reload();
    }

    exportOperatingData(){
      forkJoin([
        this.masterService.fetchApplicantsList(0, 50000, null, 'APPLICANT SURRENDERED TENEMENT', null, null, null),
        this.masterService.fetchApplicantsList(0, 50000, null, 'ACCEPTANCE PENDING', null, null, null),
        this.masterService.fetchApplicantsList(0, 50000, null, 'INELIGIBLE IN POST LOTTERY', null, null, null)
      ]).subscribe(([page1, page2, page3]) => {
        this.allPageDataAllWltType = [
          ...page1.applicationResponceWrapper.content,
          ...page2.applicationResponceWrapper.content,
          ...page3.applicationResponceWrapper.content
        ];
    
        console.log("All page data:", this.allPageDataAllWltType);
    
        if (this.allPageDataAllWltType.length > 0) {
          const lst: {[key: string]: string}[] = this.allPageDataAllWltType.map(model => {
            return {
              "Application no": model.applicationNo.toString(),
              "Applicant name": model.applicantName,
              "Lottery Name": model.lotteryEventName,
              "Status": model.applicationDrawStatus,
              "lottery code": model.lotteryEventCode,
              "Draw status": model.applicationDrawStatus,
              "Acceptance status": model.acceptanceStatus,
              "Eligibility status": model.eligibilityStatus
            };
          });

          
          const currentDate = new Date();
          
          console.log("Waitlist Operating Data", this.allPageDataAllWltTypeClmnName, 
          lst, this.allPageDataAllWltTypeClmnWdth, "SYSTEM", currentDate.toLocaleString());

          this.excelExportService.exportExcel("Waitlist Operating Data", this.allPageDataAllWltTypeClmnName, 
            lst, this.allPageDataAllWltTypeClmnWdth, "SYSTEM", currentDate.toLocaleString()
          );
        }
      }, error => {
        console.error("Error:", error);
      });
    }
  
    onLoad() {
      this.isLoading = true;
      console.log("in Onload");
      this.masterService.fetchApplicantsList(this.currentPage, this.pageSize, 
        (this.filterForm.value?.filterText != undefined ? this.filterForm.value?.filterText: null),
        (this.filterForm.value?.wlType != undefined ? this.filterForm.value?.wlType: null),
        (this.filterForm.value?.lotteryCodeFilter != undefined ? this.filterForm.value?.lotteryCodeFilter: null),
        (this.filterForm.value?.schemeCodeFilter != undefined ? this.filterForm.value?.schemeCodeFilter: null),
        (this.filterForm.value?.categoryCodeFilter != undefined ? this.filterForm.value?.categoryCodeFilter: null)
        ).subscribe((page) => {
        this.page = page.applicationResponceWrapper;

        console.log('waitlist init => ',this.page);

        // this.lotteryCodes = page.lotteryCodes;
        // this.schemeCodes = page.schemeCodes;
        // this.categoryCodes = page.categoryCodes;

        this.categoryList = page.category;
        this.schemeList = page.scheme;

        this.dataSourceLottery = new MatTableDataSource(page.applicationResponceWrapper.content);
        // console.log("Check page content >>>>> ",page.page.content);
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = page.applicationResponceWrapper.totalElements;
          console.log(this.paginator.pageIndex);
          console.log(this.paginator.length);
        });
        this.isSearchDisabled = false;
        this.isLoading = false;
      },
      (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
      });

    }
  
    onSearch() {
      if (this.filterForm.valid) {
        console.log("onSearch");
        console.log(this.filterForm.value);
        if(this.filterForm.value.lotteryCodeFilter > 0){
          this.onLoad();
        }else{
          return this.errorToast("Please select Lottery.");
        }
      }
      else {
        this._snackBar.open("Please enter Filter text (minimum - 3 char) for Lottery", "Close", {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        });
        this.isSearchDisabled = false;
      }
    }

  // ngAfterViewInit() {
  //   this.loadData(); 
  // }

  
  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  editLottery(lotteryKey: number) {
    console.log("Edit Board called ******** key for board edit"+lotteryKey);
    this.router.navigate(['/secure', 'master', 'lottery', 'au', lotteryKey]);
  }

  activateWaitList(key: number) {
    if(confirm("Do you want to Activate WaitList")) {

      console.log(key+ "for Activate waitlist");
      this.masterService.toggleActivateWaitList(key,this.selectedWaitListType).subscribe((data: any)=>{
        if(data.status === 'SUCCESS') {
          // let selectedObj = this.page.content.find(o => o.key === key);
          // selectedObj.activeFlag = 'N';
          this.successToast(data.successMsg);
          this.onLoad();
        }
        else {
          this.errorToast(data.errorMessage);
        }
      }
      );
    } 
  }


  operateAll() {
    console.log("Operate All BTN Clicked");
    this.isLoading = true;
    if(this.selectedWaitListType == null || this.selectedWaitListType === ""){
      this.isLoading = false;
      return this.errorToast("Please select Wait List Type.");
    }

    if(this.selectedLotteryCode == null || this.selectedLotteryCode === ""){
      this.isLoading = false;
      return this.errorToast("Please select lottery.");
    }

      if(confirm("Do you want to Activate WaitList For All Applicants")) {
        this.masterService.toggleActivateAllWaitList(this.selectedWaitListType,this.selectedLotteryCode,this.selectedSchemeCode
          , this.selectedCategoryCode).subscribe((data: any)=>{
          if(data.status === 'SUCCESS') {
            // this.isLoading = false;
            // let selectedObj = this.page.content.find(o => o.key === key);
            // selectedObj.activeFlag = 'N';
            this.successToast(data.successMsg);
            this.onLoad();
          }
          else {
            this.errorToast(data.errorMessage);
            // this.isLoading = false;
          }
        }
        );
      } 
     
   this.onLoad();
  }
 
  // activate(key: number) {
  //   if(confirm("Do you want to Activate the Announcement")) {
  //     this.masterService.toggleActivationAnnouncement(key, 'Y').subscribe((data: any)=>{
  //       if(data.status === 'SUCCESS') {
  //         let selectedObj = this.page.content.find(o => o.key === key);
  //         selectedObj.activeFlag = 'Y';
  //         this.successToast("Announcement Activeted.");
  //       }
  //       else {
  //         this.errorToast(data.errorMessage);
  //       }
  //     });
  //   } 
  // }

  showBoard(o1: any, o2: any) {
    if(o1 && o2 && o1.key == o2.key) {
      return o1.value;
    }
    else {
      return "";
    }
  }

  changeWebsite(e) {  
    console.log(e.target.value); 
    this.selectedWaitListType = e.target.value; 
    this.onSearch();
  }  

  changeLotteryCodeWebsite(e) {  
    console.log(e.target.value); 
    this.selectedLotteryCode = e.target.value; 
    // this.selectedSchemeCode = "";
    // this.selectedCategoryCode = "";
    this.onSearch();
  }

  changeSchemeCodeWebsite(e) {  
    console.log(e.target.value); 
    this.selectedSchemeCode = e.target.value; 
   this.onSearch();
  }  

  changeCategoryCodeWebsite(e) {  
    console.log(e.target.value); 
    this.selectedCategoryCode = e.target.value; 
    this.onSearch();
  }

  async successToast(msg: string) {
    await this._snackBar.open(
      msg,
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 10 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 10 * 1000,
    });
  }

  viewClassForDrawStatus(drawStatus: string) {
    if(drawStatus === 'Draw winner operated') {
        return 'bg-blue-400';
    }
    else if(drawStatus === 'Draw winner') {
        return 'bg-green-400';
    }
    else if(drawStatus === 'newStatus') {
        return 'bg-orange-400';
    }
    else if(drawStatus === 'Draw winner surrendered') {
        return 'bg-pink-500';
    } 
    else if(drawStatus === 'Draw waitlist surrendered') {
      return 'bg-pink-500';
    } 
    else if(drawStatus === 'Draw waitlist activated') {
      return 'bg-pink-500';
} 
    else {
        return '';
    }
  }
  
  

}
